import React, { useEffect, useState } from "react";
// Media Query
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch, useSelector } from "react-redux";
import { getMedicines } from "../reduxToolkit/features/adminPanel/medicine";
import { getProductNameFromURL } from "../hooks/getProductNameFromURL";
import { makeUrlFriendly } from "../hooks/makeUrlFriendly";
import BreadcrumbsTemplate from "../components/misc/BreadcrumbsTemplate";
import { Box, Divider, Grid, Typography } from "@mui/material";
import LoadingBox from "../components/misc/Loading";
import Seo from "../utils/Seo";
import ProductSmall from "../components/product/ProductSmall";

function SingleGeneric() {
  // Responsive
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  // UseState
  const [genericLoading, setGenericLoading] = useState(false);
  const [generic, setGeneric] = useState(null);
  const [medicineInfo, setMedicineInfo] = useState(null);

  const [catListLoading, setCatListLoading] = useState(true);
  const [catList, setCatList] = useState([]);

  const [lang, setLang] = useState("en");

  // store
  const { medicines, categories } = useSelector((state) => state.medicine);
  const { activeLangFront } = useSelector((state) => state.miscFront);
  const { webSettings } = useSelector((state) => state.webSettings);

  // Use Effect
  const dispatch = useDispatch();
  useEffect(() => {
    // if (!(medicines && medicines.length > 0))
    dispatch(getMedicines());
    setTimeout(() => {
      scroll();
    }, 250);
  }, []);

  const scroll = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Set Generic
  useEffect(() => {
    setGenericLoading(true);
    setCatListLoading(true);
    let arr = [];
    if (lang !== "" && medicines && medicines.length > 0) {
      let M = medicines.find((m) => m.lang === lang);
      if (M && M.data) {
        let arr1 = [];
        M.data.forEach((x) => {
          let obj = { ...x };
          arr1.push(obj);
        });

        arr = [...arr1].sort((a, b) =>
          a.generic.toLowerCase().replace(/\s/g, "") >
          b.generic.toLowerCase().replace(/\s/g, "")
            ? 1
            : -1
        );
      }
      setTimeout(() => {
        setGenericLoading(false);
        setCatListLoading(false);
      }, 3000);
    }
    arr = arr.filter((m) => m.visible === true);
    let tempArr = [...arr];
    let unique = [
      ...new Map(tempArr.map((item) => [item["generic"], item])).values(),
    ];
    let genericArr = [];
    unique.forEach((item) => {
      let genericObj = {
        genericName: item.generic,
        medicines: arr.filter((m) => m.generic === item.generic),
      };
      genericArr.push(genericObj);
    });

    const genericNameFromURL = getProductNameFromURL();

    const singleGeneric = genericArr.find(
      (g) => makeUrlFriendly(g.genericName) === genericNameFromURL
    );

    if (singleGeneric) {
      if (singleGeneric && singleGeneric.genericName) {
        setGeneric(singleGeneric);
      }
      if (singleGeneric.medicines.length > 0) {
        setMedicineInfo(singleGeneric.medicines[0]);
      }
    }
  }, [medicines, lang]);

  // set Category
  useEffect(() => {
    if (lang !== "" && categories && categories.length > 0) {
      let C = categories.find((c) => c.lang === lang);
      if (C) setCatList(C.data);
      else setCatList([]);
    }
  }, [categories, lang]);

  // Set Language
  useEffect(() => {
    if (activeLangFront) {
      setLang(activeLangFront.langCode);
      setCatListLoading(true);
    }
  }, [activeLangFront]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = String;
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <Box
      sx={{
        maxWidth: !smUp ? "90vw" : "100%",
        margin: "auto",
      }}
    >
      {genericLoading || catListLoading || !generic ? (
        <LoadingBox w={"100%"} h={700} />
      ) : (
        <>
          <Seo
            title={medicineInfo?.metaTitle || "Elifesaving Medicine"}
            description={
              medicineInfo?.metaDesc
                ? medicineInfo.metaDesc.replace(
                    "medicineforworld@gmail.com",
                    "info@elifesavingmedicine.com"
                  )
                : false ||
                  "Online lifesaving medicine supplying service | Elifesaving Medicine | Email: info@elifesavingmedicine.com | WhatsApp/ Wechat/ Skype: +8801719278350."
            }
            name={webSettings.companyName || "Elifesaving Medicine"}
            type="website"
            url={window.location.href || ""}
            langCode={lang}
            keyword={medicineInfo?.metaKeyword}
          />
          <BreadcrumbsTemplate
            b2={translateFront("Generics")}
            l2="/generics"
            b3={generic && generic.genericName ? generic.genericName : ""}
          />
          <Divider sx={{ mb: 2 }} />
          <Box sx={{ mx: !smUp ? 0 : mdUp ? 20 : 5 }}>
            <Typography
              variant="h1"
              color="initial"
              sx={{ fontSize: !smUp ? "1.5rem" : "2rem" }}
            >
              Generic {generic.genericName}
            </Typography>
            <Grid container spacing={2} sx={{ my: 2 }}>
              {generic.medicines.map((x, i) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                  <ProductSmall
                    x={x}
                    i={i}
                    view={0}
                    catList={catList}
                    lang={lang}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </>
      )}
    </Box>
  );
}

export default SingleGeneric;
